import './style.scss'
import { Button, Input, message, Modal } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import { FC, useEffect, useState } from 'react'
import * as HomeApi from '@/api/home'

// import { checkSensitive, showErrorwordsTip } from '@/libs/util'

interface IProps {
  open: boolean
  onOk?: () => void
  onCancel?: () => void
  group?: any
}

const CloneCustomModal: FC<IProps> = ({ open, onOk, onCancel, group }) => {
  const [config, setConfig] = useState<any>()
  const [checks, setChecks] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const [name, setName] = useState('')

  useEffect(() => {
    if (open) {
      setName('')
      getConfig()
    }
  }, [open])

  const getConfig = async () => {
    const res = await HomeApi.getTtsVoiceDesignConfig()
    setConfig(res)
    setChecks(
      res?.categories?.map((r: any) => ({
        ...r,
        category: r.title,
        tag: r.long_tags ? '声音亲切、有耐心，像一位循循善诱的老师，长时间听也不会感到疲劳。' : r?.tags?.[0]
      }))
    )
  }

  const onFilterChange = (c: any, tag: string) => {
    setChecks(
      checks?.map((check) => {
        if (check.category === c.title) {
          return {
            ...check,
            tag
          }
        }
        return check
      })
    )
  }

  const onGenerator = async () => {
    if (!name.trim()) {
      if (group?.id) {
        return message.warning('请输入风格名称')
      } else {
        return message.warning('请输入声音名称')
      }
    }

    // const errorWords = checkSensitive(
    //   checks
    //     ?.filter((c) => c.allow_typing || c.long_tags)
    //     ?.map((c) => ({
    //       words: c.tag
    //     }))
    // )

    // if (errorWords?.length) {
    //   return showErrorwordsTip(errorWords)
    // }

    const params: any = {
      tags: checks?.map((c) => ({
        category: c.category,
        tag: c.tag
      })),
      with_group: {
        new_group_title: name
      }
    }

    if (group?.id) {
      params.display_name = name
      params.with_group = {
        group_id: group.id
      }
    }

    try {
      setLoading(true)
      await HomeApi.submitTtsVoiceDesign(params)
      onCancel?.()
      onOk?.()
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Modal
        className="title-modal filter-modal custom-modal custom-modal-voice "
        title="AI捏声音"
        open={open}
        width={720}
        maskClosable={false}
        footer={
          <Button type="primary" className="custom-footer-btn" onClick={onGenerator} loading={loading}>
            立即生成
          </Button>
        }
        onCancel={onCancel}
      >
        <div className="custom-content">
          <div className="filter-fragment">
            <div className="title">
              <span>{!group?.id ? '声音名称' : '风格名称'}</span>
            </div>
          </div>
          <Input
            placeholder={group?.id ? '请输入风格名称，如高兴、沮丧等' : '请输入声音名称'}
            value={name}
            className="custom-input"
            onChange={(e) => setName(e.target.value)}
          />
          {config?.categories?.map((c: any) => (
            <div className="filter-fragment" key={c.title}>
              <div className="title">
                <span>{c.title}</span>
              </div>
              {c.allow_typing ? (
                <Input className="custom-input" onChange={(e) => onFilterChange(c, e.target.value)} />
              ) : (
                <>
                  {c?.long_tags ? (
                    <div className="long-box">
                      <Input.TextArea
                        value={checks?.find((k) => k.category === c.title)?.tag}
                        onChange={(e) => onFilterChange(c, e.target.value)}
                        placeholder={`请输入${c.title}`}
                        showCount
                        maxLength={200}
                      ></Input.TextArea>
                      <div className="recommed">
                        <span className="text">推荐：</span>
                        <div className="tag-list">
                          {c?.long_tags?.map((tag: any) => (
                            <div
                              className={`tag-item ${
                                checks?.find((check) => check.category === c.title)?.tag === tag ? 'actived' : ''
                              }`}
                              key={tag.short}
                              onClick={onFilterChange.bind(this, c, tag.long)}
                            >
                              <span>{tag.short}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="filte-list">
                      {c?.tags?.map((tag: string) => (
                        <div
                          className={`filter-item ${
                            checks?.find((check) => check.category === c.title)?.tag === tag ? 'actived' : ''
                          }`}
                          key={tag}
                          onClick={onFilterChange.bind(this, c, tag)}
                        >
                          <label>{tag}</label>
                        </div>
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>
          ))}
        </div>
      </Modal>
    </>
  )
}

export default CloneCustomModal
